<template>
  <div class="row">
    <!-- /.card-header -->
    <div class="card-body table-responsive p-0">
      <br>
      <table class="table table-hover table-fixed">
        <thead>
        <tr>
          <th>ID</th>
          <th>Дата заказа	</th>
          <th>Наименование</th>
          <th>Вес</th>
          <th>Количество</th>
          <th>Цена</th>
          <th>Адрес</th>
          <th>Телефон</th>
          <th>Доставкa	</th>
          <!--                      <th>Время доставки</th>-->
          <!--                      <th>Статус</th>-->
          <th>Комментарий</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(zakaz,key) in zakazs.data" :key="zakaz.id">
          <td :style="'border-left: 5px solid '+ colors[zakaz.color] ">{{zakaz.id}}</td>
          <td>{{zakaz.created}}</td>
          <td>{{zakaz.name}}</td>
          <td>{{zakaz.weight}}</td>
          <td>{{zakaz.number}}</td>

          <td>  {{zakaz.price}} <br/>
            <!--                           {{zakaz.anyprice}} <br/>-->
            <span style="background: #8eb4cb; color: white">{{oplata[zakaz.oplata]}}</span>
            <span  v-if="zakaz.zakcheck==='1'" class="label label-success">нужен чек</span>
          </td>
          <td>{{zakaz.adress}}<br>
            <span style="color: #8db4cb">{{zakaz.fio}}</span>
          </td>
          <td>{{zakaz.phone}}</td>
          <td>{{ new Date( zakaz.date).toLocaleDateString()  }}
            <br>
            {{zakaz.timestart}}<br>{{zakaz.timeend}}
          </td>
          <!--                      <td>{{status[zakaz.status]}}</td>-->
          <td>{{zakaz.comment}}</td>
          <td style="text-align: end">
            <!--                        <a href="#" @click="editModal(zakaz)">-->
            <!--                            <i class="fa fa-check green"></i>-->
            <!--                        </a><br>-->
<!--            <a @click="$router.push({name: 'addzakaz', params: { id: zakaz.id}});">-->
<!--              <i class="fa fa-edit blue"></i>-->
<!--            </a><br>-->
            <a href="#" @click="editModal(zakaz)">
              <i class="fa fa-print purple"></i>
            </a><br>

<!--            <a href="#" @click="deleteProduct(zakaz.id)">-->
<!--              <i class="fa fa-trash red"></i>-->
<!--            </a>-->
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- /.card-body -->
    <div class="card-footer">
      <pagination :data="zakazs" @pagination-change-page="getResults" :limit="5">
        <span slot="prev-nav">&lt; Назад</span>
        <span slot="next-nav">Вперед &gt;</span>
      </pagination>
    </div>
  </div>

</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import * as url from "url";

export default {
  components: {
    VueTagsInput,
  },
  data () {
    return {
      editmode: false,
      res : [],
      zakazs : {},
      form: new Form({
        id : '',
        category : '',
        name: '',
        photo: '',
        weight: '',
        category_id: '',
        catalog_name_id: '',
        photoUrl: '',
      }),
      oplata : {
        '1' : 'Безнал',
        '2' : 'Нал',
        '3' : 'Оплачен',
        '4' : 'Другое'
      },
      status :{
        '1' : 'В работе',
        '2' : 'Выполнен',
        '3' : 'Клиент',
        '4' : 'Передан курьеру'
      },
      colors : {
        '1' : '#3097d1',
        '2' : '#49f835',
        '3' : '#088A08',
        '4' : '#e45252'
      },
      optionsizes: [
        { text: '10', value: '10' },
        { text: '20', value: '20' },
        { text: '50', value: '50' },
        { text: '100',value: '100'}
      ],
      categories: [],
      search: '',
      date: '',
      time:  '00:00',
      timetwo: '00:00',
      autocompleteItems: [],
      urls: {
        getdata: "api/zakazlist?page=",
        update: "api/zakazlist/update",
        create: "api/zakazlist/",
        delete: "api/zakazlist/",
        name: "api/catalog/",
      },
    }
  },
  methods: {
    clean(){
      this.date = ''
      this.time = '00:00'
      this.timetwo = '00:00'
      //this.searchInTheList('')
    },
    clearSearchItem(){
      this.searchItem = undefined
      this.searchInTheList('')
    },

    getName(id) {
      axios.get(this.urls.name+id)
          .then(response => {
            this.link = response.data;
          })
          .catch((errors) => {
            this.toastError(errors.response.data.errors);
          });
    },
    getResults(page = 1) {
      this.$Progress.start();
      axios.get(this.urls.getdata + page, {
        params: {
          list: 5,
          search: this.search,
        }
      })
          .then(({ data }) => (this.zakazs = data.data));
      this.$Progress.finish();
    },
    editModal(product){
      this.editmode = true;
      this.form.reset();
      $('#addNew').modal('show');
      this.form.fill(product);
    },
    newModal(){
      this.editmode = false;
      this.form.reset();
      $('#addNew').modal('show');
    },
    createProduct(){
      this.$Progress.start();
      this.form.post(this.urls.create)
          .then((data)=>{
            if(data.data.success){
              $('#addNew').modal('hide');

              Toast.fire({
                icon: 'success',
                title: data.data.message
              });
              this.getResults();
              this.$Progress.finish();
            } else {
              Toast.fire({
                icon: 'error',
                title: 'Some error occured! Please try again'
              });

              this.$Progress.failed();
            }
          })
          .catch(()=>{

            Toast.fire({
              icon: 'error',
              title: 'Some error occured! Please try again'
            });
          })
    },
    updateProduct(){
      this.$Progress.start();
      this.form.put(this.urls.update+this.form.id)
          .then((response) => {
            // success
            $('#addNew').modal('hide');
            Toast.fire({
              icon: 'success',
              title: response.data.message
            });
            this.$Progress.finish();
            //  Fire.$emit('AfterCreate');

            this.getResults();
          })
          .catch(() => {
            this.$Progress.fail();
          });

    },
    deleteProduct(id){
      Swal.fire({
        title: 'Вы хотите удалить заказ',
        text: "под номером " + id,
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: 'Отмена',
        confirmButtonText: 'Удалить'
      }).then((result) => {
        if (result.value) {
          this.form.delete(this.urls.delete + id).then(()=>{
            Swal.fire(
                'Deleted!',
                'Заказ успешно удален',
                'success'
            );
            // Fire.$emit('AfterCreate');
            this.getResults();
          }).catch((data)=> {
            Swal.fire("Failed!", data.message, "warning");
          });
        }
      })
    },

  },
  mounted() {

  },
  created() {
    this.$Progress.start();
    this.getResults();
    this.$Progress.finish();
  },
  computed: {

    number(data){
      console.log(data);

    }

    // filteredProducts: function() {
    //     console.log(this.catalogs);
    //     return this.catalogs.filter(catalog => {
    //         return catalog.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
    //     });
    // }
  },
}
</script>
